<template>
  <wh-popup
    v-model="myVisible"
    :ref-form="$refs.PackingPopup"
    :title="title"
    @close="hidePopup"
    @open="open"
  >
    <van-form
      ref="PackingPopup"
      class="packing-popup"
      label-width="60px"
      @submit="submitForm"
    >
      <div class="main">
        <van-field
          v-model="form.productName"
          :rules="rules.productName"
          label="产品名称"
          name="产品名称"
          placeholder="请输入产品名称"
        />
        <wh-popup-select
          v-model="form.raw"
          :columns="productSelect"
          class="raw-selete"
          label="半成品"
          placeholder="请选择半成品"
          @change="changeFn"
        />
        <div v-for="(i,key) in form.ParPreparedProducts||[]" :key="key">
          <div v-if="!i.deleted" class="raw-list wh-flex-between">
            <div class="material-name van-ellipsis">
              {{ i.name }}
            </div>
            <div>库存：{{ i.proQuantity }}</div>
            <div class="wh-flex-start count" style="width: 100px">
              <span>用量：</span>
              <van-field
                v-model.number="i.quantity"
                :disabled="i.flag"
                class="quantity"
                input-align="center"
                type="number"
              />
              <span>
                {{ i.unit }}
              </span>
            </div>
            <div>
              <van-icon v-if="!i.flag" color="#20CAA0" name="checked" size="20" @click="subRaw(i)" />
              <svg-icon v-else icon-class="edit" style="width:20px;height:20px" @click.native="i.flag = !i.flag" />
              <van-icon color="#FF4444" name="delete" size="20" @click="delRaw(i,key)" />
            </div>
          </div>
        </div>
        <van-field :rules="rules.unit" :value="form.specificationQuantity" label="包装规格">
          <template #input>
            <div class="unit-box">
              <van-stepper
                v-model.number="form.specificationQuantity"
                :min="0"
                decimal-length="2"
                input-width="60px"
              />
              <wh-select-popup v-model="form.specificationUint" :options="unitOptions" placeholder="单位" />
              <wh-select-popup v-model="form.specificationPacking" :options="packOptions" placeholder="单位" />
            </div>
          </template>
        </van-field>
        <van-field :rules="rules.packingQuantity" :value="form.packingQuantity" label="数量">
          <template #input>
            <van-stepper
              v-model.number="form.packingQuantity"
              :min="0"
              input-width="80px"
            />
            <span style="margin-left: 5px">{{ form.specificationPacking }}</span>
          </template>
        </van-field>
        <wh-field-time-popup v-model="form.packingTime" :rules="rules.packingTime" input-align="left" label="生产日期" />
        <van-field :rules="rules.QGPTime" :value="form.QGPTime" label="保质期">
          <template #input>
            <div class="unit-box">
              <van-stepper
                v-model.number="form.QGPTime"
                :min="0"
                input-width="60px"
              />
              <wh-select-popup v-model="form.QGPUnit" :options="['年','月','天']" placeholder="单位" />
            </div>
          </template>
        </van-field>
        <wh-staff v-model="form.staffName" :rules="rules.staffName" lable="操作人" />
        <van-field
          v-model="form.productIntroduction"
          autosize=""
          label="产品简介"
          maxlength="200"
          placeholder="请输入产品简介"
          rows="3"
          show-word-limit
          type="textarea"
        />
        <div style="padding:0 16px">
          <wh-upload v-model="form.photo" :files-str.sync="photoStr" :max-count="3" />
        </div>
      </div>
    </van-form>
  </wh-popup>
</template>
<script>
import api from '@/api'
import WhPopup from '@/components/public/WhPopup/WhPopup'
import { packOptions, unitOptions } from '@/constant/common'
import { formPopup } from '@/utils/mixins/formPopup'
import WhPopupSelect from '@/components/public/WhPopupSelect/WhPopupSelect.vue'
import WhSelectPopup from '@/components/public/WhSelectPopup/WhSelectPopup'
import WhFieldTimePopup from '@/components/public/WhFieldTimePopup/WhFieldTimePopup'
import WhStaff from '@/components/public/WhStaff/WhStaff.vue'
import WhUpload from '@/components/public/WhUpload/WhUpload.vue'

export default {
  components: { WhPopup, WhPopupSelect, WhSelectPopup, WhFieldTimePopup, WhStaff, WhUpload },
  mixins: [formPopup],
  data() {
    const unitValidator = (value, rule) => {
      return !!this.form.specificationQuantity && !!this.form.specificationUint && !!this.form.specificationPacking
    }
    const dateValidator = (rule, value, callback) => {
      return !!this.form.QGPTime && !!this.form.QGPUnit
    }
    return {
      unitOptions,
      packOptions,
      rules: {
        productName: [{ required: true, message: '请输入产品名称' }],
        process: [{ required: true, message: '请选择加工过程', trigger: 'onChange' }],
        unit: [{ validator: unitValidator, message: '请选择完整的包装规格' }],
        packingQuantity: [{ validator: val => val >= 0, message: '请输入包装数量' }],
        packingTime: [{ required: true, message: '请选择包装时间' }],
        staffName: [{ required: true, message: '请选择操作人' }],
        QGPTime: [{ validator: dateValidator, message: '请选择完整的保质期' }]
      },
      form: {
        productName: '',
        id: undefined,
        packingQuantity: 0,
        packingTime: '',
        photo: [],
        processingJson: {},
        productIntroduction: '',
        ParPreparedProducts: [],
        specificationPacking: 'g',
        specificationQuantity: undefined,
        specificationUint: '袋',
        staffName: '',
        QGPUnit: '月'
      },
      photoStr: '',
      productSelect: [],
      productList: []
    }
  },
  computed: {
    title() {
      return this.formType === 'create' ? '新增包装' : '编辑包装'
    }
  },
  watch: {
    visible: {
      handler(newV) {
        this.$nextTick(() => {
          this.$refs.PackingPopup.resetValidation()
        })
      }
    }
  },
  methods: {
    unique(arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    getProduct() {
      this.productList = []
      this.productSelect = []
      api.getParPreparedProductsList().then(res => {
        this.productList = res.data.list
        res.data.list.forEach(i => {
          if (i.quantity) {
            this.productSelect.push({
              text: `${i.name}  剩余:${i.quantity + i.unit}`,
              value: i.id
            })
          }
        })
      })
    },
    subRaw(i) {
      if (i.recordsQuantity > i.quantity) {
        this.$toast.fail('输入数量超过库存')
      } else {
        i.flag = true
      }
    },
    delRaw(row, index) {
      this.$dialog.confirm({
        message: '确认删除?'
      }).then(() => {
        if (row.id) {
          this.form.ParPreparedProducts.splice(index, 1)
          return
        }
        if (row.deleted === 0) {
          row.deleted = 1
        }
      }).catch(() => {
      })
    },
    changeFn(val) {
      this.productList.map(item => {
        if (item.id === val && item.quantity) {
          console.log(item)
          this.form.ParPreparedProducts.push({
            ...item,
            proQuantity: item.quantity,
            quantity: 0,
            mngId: item.id,
            flag: false
          })
        }
      })
    },
    submitForm() {
      if (!this.form.ParPreparedProducts.length) {
        this.$toast.fail('原料未选择')
        return
      } else {
        if (this.form.ParPreparedProducts.some(i => {
          return !i.flag
        })) {
          this.$toast.fail('部分原料未确定')
          return
        }
      }
      if (this.form.id) {
        const editForm = {
          ...this.form,
          photo: this.photoStr,
          ParPreparedProducts: this.form.ParPreparedProducts.map(item => {
            return {
              ...item,
              recordsQuantity: -item.recordsQuantity
            }
          })
        }
        api.updatePackingManagement(editForm).then(res => {
          this.$toast('编辑包装成功')
          this.hidePopup()
          this.submitFormSuccess()
        })
      } else {
        const createForm = {
          ...this.form,
          photo: this.photoStr,
          ParPreparedProducts: this.form.ParPreparedProducts.map(item => {
            return {
              ...item,
              recordsQuantity: -item.recordsQuantity
            }
          })
        }
        api.createPackingManagementJL(createForm).then(res => {
          this.$toast('添加包装成功')
          this.hidePopup()
          this.submitFormSuccess()
        })
      }
    },

    async open() {
      await this.getProduct()
      if (this.formType === 'create') {
        this.formDataInit(this.form)
      } else {
        this.formDataInit(this.form, this.initFormData)
        if (this.form.processingJson) {
          this.form.process = this.form.processingJson.id
        }
        if ((this.form.ParPreparedProducts || []).length) {
          this.form.ParPreparedProducts = this.form.ParPreparedProducts.map(i => {
            return {
              ...i,
              recordsQuantity: Math.abs(i.recordsQuantity),
              flag: true,
              deleted: 0
            }
          })
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.main {
  background-color: #fff;
  .raw-selete {
    /deep/ .van-field__control {
      display: none;
    }
  }
  .raw-list {
    padding: 5px 16px;
    margin-bottom: 2px;
    font-size: 12px;
    background-color: rgba(32, 202, 160, 0.12);
    word-break: keep-all;
    .material-name {
      width: 100px;
      &::before {
        content: '';
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background-color: #20CAA0;
        margin-right: 6px;
        margin-bottom: 2px;
      }
    }
    .quantity {
      width: 60px;
      font-size: 12px;
      padding: 0;
      background-color: #fff;
    }
  }
  .unit-box {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
